(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-hub-du-bois"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var button = event.target.closest('[data-blog-hub-load-more]');
    if (!button) return;

    var section = button.closest('.blog-hub-du-bois');
    if (!section) return;

    var increment = parseInt(button.getAttribute('data-increment'), 10) || 6;
    var hiddenArticles = Array.prototype.slice.call(section.querySelectorAll('[data-blog-hub-article][hidden]'));

    hiddenArticles.slice(0, increment).forEach(function(article) {
      article.removeAttribute('hidden');
    });

    if (section.querySelectorAll('[data-blog-hub-article][hidden]').length === 0) {
      button.closest('.blog-hub-du-bois__load-more-wrap').remove();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["connection-types-page"]) return;
  try {
    
  if (!customElements.get('coupling-hub')) {
    customElements.define('coupling-hub', class extends HTMLElement {
      connectedCallback() {
        this.filters = [...this.querySelectorAll('[data-coupling-filter]')];
        this.cards = [...this.querySelectorAll('[data-coupling-card]')];
        this.empty = this.querySelector('[data-coupling-empty]');
        this.filters.forEach((button) => button.addEventListener('click', () => this.filter(button)));
      }

      filter(button) {
        const category = button.dataset.couplingFilter;
        const update = () => {
          let visible = 0;
          this.filters.forEach((item) => {
            const active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', active.toString());
          });
          this.cards.forEach((card) => {
            const show = category === 'all' || card.dataset.category === category;
            card.hidden = !show;
            if (show) visible += 1;
          });
          if (this.empty) this.empty.hidden = visible > 0;
        };

        if (document.startViewTransition) document.startViewTransition(update);
        else update();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coupling-finder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('coupling-finder')) {
    customElements.define('coupling-finder', class extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('[data-finder-form]');
        this.first = this.querySelector('[data-finder-first]');
        this.second = this.querySelector('[data-finder-second]');
        this.secondField = this.querySelector('[data-second-field]');
        this.explanation = this.querySelector('[data-finder-explanation]');
        this.firstLabel = this.querySelector('[data-first-label]');
        this.status = this.querySelector('[data-finder-status]');
        this.submit = this.querySelector('[data-finder-submit]');
        this.modeButtons = [...this.querySelectorAll('[data-finder-mode]')];
        this.availableValues = new Set([...this.first.options].filter((option) => option.value && option.dataset.compatible).map((option) => option.value));
        this.namedProductValues = new Set([...this.first.options].map((option) => option.dataset.matchValue).filter(Boolean));

        this.modeButtons.forEach((button) => button.addEventListener('click', () => this.setMode(button.dataset.finderMode, true)));
        this.first.addEventListener('change', () => this.update());
        this.second.addEventListener('change', () => this.updateStatus());
        this.form.addEventListener('submit', (event) => this.submitFinder(event));

        const params = new URLSearchParams(window.location.search);
        const requestedMode = params.get('zoekroute');
        this.setMode(requestedMode === 'adapter' || requestedMode === 'pair' ? 'pair' : 'single');
        this.selectValue(this.first, params.get('a'));
        this.update();
        this.selectValue(this.second, params.get('b'));
        this.updateStatus();
      }

      setMode(mode, focus = false) {
        this.mode = mode;
        const needsPair = mode !== 'single';
        this.modeButtons.forEach((button) => {
          const active = button.dataset.finderMode === mode;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active.toString());
        });
        this.secondField.hidden = !needsPair;
        this.second.required = needsPair;
        if (!needsPair) this.second.value = '';
        this.updateFirstOptions();
        this.explanation.textContent = this.dataset[`${mode}Text`];
        this.firstLabel.textContent = needsPair ? this.dataset.pairFirstLabel : this.dataset.singleFirstLabel;
        this.first.options[0].textContent = needsPair ? this.dataset.pairPlaceholder : this.dataset.singlePlaceholder;
        this.second.options[0].textContent = this.dataset.pairPlaceholder;
        this.submit.querySelector('span').textContent = needsPair ? 'Zoek deze combinatie' : 'Bekijk deze koppelingen';
        this.update();
        if (focus) this.first.focus();
      }

      selectValue(select, value) {
        if (value && [...select.options].some((option) => !option.disabled && option.value === value)) select.value = value;
      }

      updateFirstOptions() {
        const allowedValues = this.mode === 'single' ? this.namedProductValues : this.availableValues;
        [...this.first.options].forEach((option) => {
          if (!option.value) return;
          const available = allowedValues.has(option.value);
          option.hidden = !available;
          option.disabled = !available;
        });
        if (!allowedValues.has(this.first.value)) this.first.value = '';
      }

      update() {
        const selected = this.first.value;
        const compatible = new Set(this.compatibleValues(selected));

        [...this.second.options].forEach((option) => {
          if (!option.value) return;
          const baseLabel = option.dataset.baseLabel || option.textContent;
          option.dataset.baseLabel = baseLabel;
          const available = compatible.has(option.value);
          option.hidden = !available;
          option.disabled = !available;
          option.textContent = option.value === this.directMate(selected)
            ? `${baseLabel} (direct passend)`
            : baseLabel;
        });
        if (!compatible.has(this.second.value)) this.second.value = '';
        this.second.disabled = !selected || this.mode === 'single';
        this.updateStatus();
      }

      updateStatus() {
        const firstValue = this.first.value;
        const secondValue = this.second.value;
        if (this.mode !== 'single') this.submit.querySelector('span').textContent = 'Zoek deze combinatie';
        if (!firstValue) {
          this.status.textContent = 'Kies eerst een aansluiting.';
          this.submit.disabled = true;
          return;
        }
        if (this.mode === 'single') {
          const productOption = this.productOptionFor(firstValue);
          this.status.textContent = productOption
            ? 'Je krijgt producten waarop exact deze gekozen aansluiting voorkomt.'
            : 'Voor deze koppelingsnaam is geen productroute beschikbaar.';
          this.submit.disabled = !productOption;
          return;
        }
        if (!secondValue) {
          this.status.textContent = 'Kies nu de aansluiting aan de andere zijde. Alleen beschikbare combinaties worden getoond.';
          this.submit.disabled = true;
          return;
        }
        const available = this.compatibleValues(firstValue).includes(secondValue);
        const direct = this.isDirectPair(firstValue, secondValue);
        this.submit.querySelector('span').textContent = direct ? 'Bekijk passende onderdelen' : 'Zoek deze combinatie';
        this.status.textContent = direct
          ? 'Deze aansluitingen zitten op twee afzonderlijke onderdelen en passen rechtstreeks in elkaar. Je hebt geen extra koppeling of verloopstuk nodig.'
          : available ? 'Voor deze twee aansluitingen is een passende verbinding beschikbaar.' : 'Deze combinatie is niet beschikbaar.';
        this.submit.disabled = !available;
      }

      compatibleValues(value) {
        const option = [...this.first.options].find((item) => item.value === value);
        return option?.dataset.compatible?.split(/\r?\n/).map((item) => item.trim()).filter(Boolean) || [];
      }

      isDirectPair(firstValue, secondValue) {
        const option = [...this.first.options].find((item) => item.value === firstValue);
        return Boolean(firstValue && secondValue && option?.dataset.directMate === secondValue);
      }

      directMate(value) {
        const option = [...this.first.options].find((item) => item.value === value);
        return option?.dataset.directMate || '';
      }

      productOptionFor(value) {
        return [...this.first.options].find((option) => option.dataset.matchValue === value);
      }

      submitFinder(event) {
        event.preventDefault();
        const firstValue = this.first.value;
        if (!firstValue) return;

        if (this.mode === 'single') {
          const productOption = this.productOptionFor(firstValue);
          if (productOption) window.location.assign(`${this.dataset.catalogUrl}/${productOption.dataset.tagHandle}`);
          return;
        }

        if (!this.compatibleValues(firstValue).includes(this.second.value)) return;
        const firstOption = this.first.selectedOptions[0];
        const secondOption = this.second.selectedOptions[0];
        if (this.isDirectPair(firstValue, this.second.value)) {
          window.location.assign(`${this.dataset.catalogUrl}/${firstOption.dataset.tagHandle}`);
          return;
        }
        if (firstValue === this.second.value) {
          if (firstOption.dataset.samePairTagHandle) window.location.assign(`${this.dataset.catalogUrl}/${firstOption.dataset.samePairTagHandle}`);
          return;
        }
        const tags = [firstOption.dataset.tagHandle, secondOption.dataset.tagHandle].sort();
        window.location.assign(`${this.dataset.catalogUrl}/${tags.join('+')}`);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coupling-systems"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('coupling-systems')) {
    customElements.define('coupling-systems', class extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('[data-coupling-filter]').forEach((button) => button.addEventListener('click', () => {
          const category = button.dataset.couplingFilter;
          let visible = 0;
          this.querySelectorAll('[data-coupling-filter]').forEach((item) => { const active = item === button; item.classList.toggle('is-active', active); item.setAttribute('aria-pressed', active.toString()); });
          this.querySelectorAll('[data-coupling-card]').forEach((card) => { const show = category === 'all' || card.dataset.category === category; card.hidden = !show; if (show) visible += 1; });
          this.querySelector('[data-coupling-empty]').hidden = visible > 0;
        }));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["exploded-view-main"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const hotspots = document.querySelectorAll('.parts-hotspot[data-position]');
    const rows = document.querySelectorAll('.parts-list__row[data-position]');
    const qtyButtons = document.querySelectorAll('.parts-qty-btn');
    const diagram = document.querySelector('.parts-diagram');
    const diagramCanvas = document.querySelector('.parts-diagram__canvas');
    const zoomButtons = document.querySelectorAll('[data-zoom-action]');
    const diagramStatus = document.querySelector('[data-parts-status]');
    const hotspotPreview = document.querySelector('[data-hotspot-preview-image]')?.closest('.parts-hotspot-preview');
    const hotspotPreviewImage = document.querySelector('[data-hotspot-preview-image]');
    const hotspotPreviewTitle = document.querySelector('[data-hotspot-preview-title]');
    const cartSurface = document.querySelector('cart-notification, cart-drawer');
    const canHover = window.matchMedia('(hover: hover)');
    const productForms = document.querySelectorAll('.parts-product-form form');
    const minZoom = 1;
    const maxZoom = 4;
    const activePointers = new Map();
    let diagramScale = 1;
    let diagramX = 0;
    let diagramY = 0;
    let lastPanPoint = null;
    let lastPinchDistance = 0;
    let movedDiagram = false;
    let pendingPartsAdd = false;
    let suppressNextCartSurfaceOpen = false;
    let activePreviewHotspot = null;
    let previewRequestId = 0;

    function clearActive() {
      hotspots.forEach(function (hotspot) {
        hotspot.classList.remove('is-active');
      });

      rows.forEach(function (row) {
        row.classList.remove('is-active');
      });
    }

    function setActive(position) {
      clearActive();

      document
        .querySelectorAll('[data-position="' + position + '"]')
        .forEach(function (element) {
          element.classList.add('is-active');
        });
    }

    function setSelected(position) {
      document.querySelectorAll('.parts-hotspot.is-selected, .parts-list__row.is-selected').forEach(function (element) {
        element.classList.remove('is-selected');
      });

      document.querySelectorAll('[data-position="' + position + '"]').forEach(function (element) {
        element.classList.add('is-selected');
      });

      if (diagramStatus && diagram) {
        diagramStatus.textContent = diagram.dataset.selectedLabel + ' ' + position + '.';
      }
    }

    function clearSelected() {
      document.querySelectorAll('.parts-hotspot.is-selected, .parts-list__row.is-selected').forEach(function (element) {
        element.classList.remove('is-selected');
      });
    }

    function hideHotspotPreview() {
      activePreviewHotspot = null;
      previewRequestId += 1;

      if (!hotspotPreview) {
        return;
      }

      hotspotPreview.hidden = true;
      hotspotPreview.setAttribute('aria-hidden', 'true');
      hotspotPreview.classList.remove('is-below');
    }

    function positionHotspotPreview(hotspot) {
      const diagramRect = diagram.getBoundingClientRect();
      const hotspotRect = hotspot.getBoundingClientRect();
      const previewRect = hotspotPreview.getBoundingClientRect();
      const edge = previewRect.width / 2 + 8;
      const left = clamp(hotspotRect.left - diagramRect.left + hotspotRect.width / 2, edge, diagramRect.width - edge);
      const aboveTop = hotspotRect.top - diagramRect.top - 10;

      hotspotPreview.style.left = left + 'px';

      if (aboveTop - previewRect.height < 8) {
        hotspotPreview.classList.add('is-below');
        hotspotPreview.style.top = hotspotRect.bottom - diagramRect.top + 10 + 'px';
      } else {
        hotspotPreview.classList.remove('is-below');
        hotspotPreview.style.top = aboveTop + 'px';
      }
    }

    function showHotspotPreview(hotspot, allowWithoutHover) {
      if (!hotspotPreview || !hotspotPreviewImage || !hotspotPreviewTitle || !hotspot.dataset.previewImage) {
        return;
      }

      if (!canHover.matches && !allowWithoutHover) {
        return;
      }

      activePreviewHotspot = hotspot;
      previewRequestId += 1;
      const currentRequestId = previewRequestId;
      hotspotPreviewTitle.textContent = hotspot.dataset.previewTitle || '';
      hotspotPreview.hidden = true;
      hotspotPreview.setAttribute('aria-hidden', 'true');
      hotspotPreviewImage.removeAttribute('src');
      hotspotPreviewImage.alt = hotspot.dataset.previewTitle || '';

      const revealPreview = function () {
        if (currentRequestId !== previewRequestId || activePreviewHotspot !== hotspot) {
          return;
        }

        hotspotPreview.hidden = false;
        hotspotPreview.setAttribute('aria-hidden', 'false');
        positionHotspotPreview(hotspot);
      };

      hotspotPreviewImage.onload = revealPreview;
      hotspotPreviewImage.onerror = function () {
        if (currentRequestId === previewRequestId) {
          hideHotspotPreview();
        }
      };
      hotspotPreviewImage.src = hotspot.dataset.previewImage;

      if (hotspotPreviewImage.complete && hotspotPreviewImage.naturalWidth > 0) {
        requestAnimationFrame(revealPreview);
      }
    }

    function scrollToRow(position) {
      const row = document.querySelector('.parts-list__row[data-position="' + position + '"]');

      if (row) {
        row.scrollIntoView({ behavior: 'smooth', block: 'center' });
        row.focus({ preventScroll: true });
      }
    }

    function scrollToDiagramAfterAdd() {
      if (!diagram) {
        return;
      }

      clearActive();
      clearSelected();
      hideHotspotPreview();

      if (window.location.hash) {
        window.history.replaceState(null, '', window.location.pathname + window.location.search);
      }

      if (diagramStatus) {
        diagramStatus.textContent = diagram.dataset.addedMessage;
      }

      diagram.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function clamp(value, min, max) {
      return Math.min(Math.max(value, min), max);
    }

    function clampDiagramPosition() {
      if (!diagram || !diagramCanvas) {
        return;
      }

      if (diagramScale <= 1) {
        diagramScale = 1;
        diagramX = 0;
        diagramY = 0;
        return;
      }

      const viewport = diagram.getBoundingClientRect();
      const image = diagramCanvas.querySelector('.parts-diagram__image');
      const baseWidth = image ? image.offsetWidth : diagramCanvas.offsetWidth;
      const baseHeight = image ? image.offsetHeight : diagramCanvas.offsetHeight;
      const scaledWidth = baseWidth * diagramScale;
      const scaledHeight = baseHeight * diagramScale;
      const minX = Math.min(0, viewport.width - scaledWidth);
      const minY = Math.min(0, viewport.height - scaledHeight);

      diagramX = scaledWidth <= viewport.width ? (viewport.width - scaledWidth) / 2 : clamp(diagramX, minX, 0);
      diagramY = scaledHeight <= viewport.height ? (viewport.height - scaledHeight) / 2 : clamp(diagramY, minY, 0);
    }

    function applyDiagramTransform() {
      if (!diagramCanvas) {
        return;
      }

      clampDiagramPosition();
      diagramCanvas.style.transform = 'translate3d(' + diagramX + 'px, ' + diagramY + 'px, 0) scale(' + diagramScale + ')';
      diagramCanvas.style.setProperty('--hotspot-scale', String(1 / diagramScale));
    }

    function zoomDiagramTo(nextScale, clientX, clientY) {
      if (!diagram) {
        return;
      }

      const oldScale = diagramScale;
      const rect = diagram.getBoundingClientRect();
      const focusX = typeof clientX === 'number' ? clientX - rect.left : rect.width / 2;
      const focusY = typeof clientY === 'number' ? clientY - rect.top : rect.height / 2;
      const contentX = (focusX - diagramX) / oldScale;
      const contentY = (focusY - diagramY) / oldScale;

      diagramScale = clamp(nextScale, minZoom, maxZoom);
      diagramX = focusX - contentX * diagramScale;
      diagramY = focusY - contentY * diagramScale;
      applyDiagramTransform();
    }

    function pointerDistance(pointerA, pointerB) {
      return Math.hypot(pointerA.clientX - pointerB.clientX, pointerA.clientY - pointerB.clientY);
    }

    function pointerCenter(pointerA, pointerB) {
      return {
        x: (pointerA.clientX + pointerB.clientX) / 2,
        y: (pointerA.clientY + pointerB.clientY) / 2
      };
    }

    if (diagram && diagramCanvas) {
      diagram.addEventListener('pointerdown', function (event) {
        if (event.target.closest('[data-zoom-action]') || event.target.closest('.parts-hotspot')) {
          return;
        }

        activePointers.set(event.pointerId, { clientX: event.clientX, clientY: event.clientY });
        diagram.setPointerCapture(event.pointerId);
        diagram.classList.add('is-dragging');
        movedDiagram = false;

        if (activePointers.size === 1) {
          lastPanPoint = { x: event.clientX, y: event.clientY };
        }

        if (activePointers.size === 2) {
          const pointers = Array.from(activePointers.values());
          lastPinchDistance = pointerDistance(pointers[0], pointers[1]);
        }
      });

      diagram.addEventListener('pointermove', function (event) {
        if (!activePointers.has(event.pointerId)) {
          return;
        }

        activePointers.set(event.pointerId, { clientX: event.clientX, clientY: event.clientY });

        if (activePointers.size === 2) {
          event.preventDefault();
          const pointers = Array.from(activePointers.values());
          const nextDistance = pointerDistance(pointers[0], pointers[1]);
          const center = pointerCenter(pointers[0], pointers[1]);

          if (lastPinchDistance > 0) {
            zoomDiagramTo(diagramScale * (nextDistance / lastPinchDistance), center.x, center.y);
          }

          lastPinchDistance = nextDistance;
          movedDiagram = true;
          return;
        }

        if (diagramScale > 1 && lastPanPoint) {
          event.preventDefault();
          diagramX += event.clientX - lastPanPoint.x;
          diagramY += event.clientY - lastPanPoint.y;
          lastPanPoint = { x: event.clientX, y: event.clientY };
          movedDiagram = true;
          applyDiagramTransform();
        }
      });

      ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (eventName) {
        diagram.addEventListener(eventName, function (event) {
          activePointers.delete(event.pointerId);
          lastPinchDistance = 0;
          lastPanPoint = null;

          if (activePointers.size === 0) {
            diagram.classList.remove('is-dragging');
          }

          if (activePointers.size === 1) {
            const remainingPointer = Array.from(activePointers.values())[0];
            lastPanPoint = { x: remainingPointer.clientX, y: remainingPointer.clientY };
          }
        });
      });

      diagram.addEventListener('wheel', function (event) {
        event.preventDefault();
        const zoomStep = event.deltaY < 0 ? .25 : -.25;
        zoomDiagramTo(diagramScale + zoomStep, event.clientX, event.clientY);
      }, { passive: false });

      diagram.addEventListener('dblclick', function (event) {
        if (event.target.closest('[data-zoom-action]')) {
          return;
        }

        event.preventDefault();

        if (diagramScale > 1) {
          diagramScale = 1;
          diagramX = 0;
          diagramY = 0;
          applyDiagramTransform();
        } else {
          zoomDiagramTo(2, event.clientX, event.clientY);
        }
      });
    }

    zoomButtons.forEach(function (button) {
      button.addEventListener('pointerdown', function (event) {
        event.stopPropagation();
      });

      button.addEventListener('dblclick', function (event) {
        event.stopPropagation();
      });

      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        const action = button.dataset.zoomAction;

        if (action === 'reset') {
          diagramScale = 1;
          diagramX = 0;
          diagramY = 0;
          applyDiagramTransform();
          return;
        }

        if (action === 'in') {
          zoomDiagramTo(diagramScale + .5);
        }

        if (action === 'out') {
          zoomDiagramTo(diagramScale - .5);
        }
      });
    });

    hotspots.forEach(function (hotspot) {
      hotspot.addEventListener('pointerdown', function (event) {
        event.stopPropagation();
        movedDiagram = false;
      });

      hotspot.addEventListener('mouseenter', function () {
        setActive(hotspot.dataset.position);
        showHotspotPreview(hotspot, false);
      });

      hotspot.addEventListener('mouseleave', function () {
        clearActive();
        hideHotspotPreview();
      });

      hotspot.addEventListener('focus', function () {
        setActive(hotspot.dataset.position);
        showHotspotPreview(hotspot, true);
      });

      hotspot.addEventListener('blur', function () {
        clearActive();
        hideHotspotPreview();
      });

      hotspot.addEventListener('click', function (event) {
        event.stopPropagation();

        if (movedDiagram) {
          event.preventDefault();
          return;
        }

        event.preventDefault();
        setActive(hotspot.dataset.position);
        setSelected(hotspot.dataset.position);
        window.history.replaceState(null, '', '#part-row-' + encodeURIComponent(hotspot.dataset.position));
        scrollToRow(hotspot.dataset.position);
      });
    });

    rows.forEach(function (row) {
      row.addEventListener('mouseenter', function () {
        setActive(row.dataset.position);
      });

      row.addEventListener('mouseleave', clearActive);
    });

    qtyButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        const control = button.closest('.parts-cart-control');
        const input = control.querySelector('.parts-list__qty');
        const currentValue = parseInt(input.value || '1', 10);
        const action = button.dataset.action;

        if (action === 'minus') {
          input.value = Math.max(1, currentValue - 1);
        }

        if (action === 'plus') {
          input.value = currentValue + 1;
        }

        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    productForms.forEach(function (form) {
      form.addEventListener('submit', function () {
        pendingPartsAdd = true;
        suppressNextCartSurfaceOpen = true;
      });
    });

    if (cartSurface && typeof cartSurface.open === 'function') {
      const openCartSurface = cartSurface.open.bind(cartSurface);

      cartSurface.open = function () {
        if (suppressNextCartSurfaceOpen) {
          suppressNextCartSurfaceOpen = false;
          return;
        }

        openCartSurface();
      };
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (!pendingPartsAdd || event.source !== 'product-form') {
          return;
        }

        pendingPartsAdd = false;
        scrollToDiagramAfterAdd();
      });

      subscribe(PUB_SUB_EVENTS.cartError, function (event) {
        if (pendingPartsAdd && event.source === 'product-form') {
          pendingPartsAdd = false;
          suppressNextCartSurfaceOpen = false;
        }
      });
    }

    if (window.location.hash.indexOf('#part-row-') === 0) {
      setSelected(decodeURIComponent(window.location.hash.replace('#part-row-', '')));
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
